import { get_data } from "./get_data";
export function setProgressBar(step: string) {   
    let percent;
    let isMRAWarranty:Boolean = get_data('conceptID') == '8' && window?.objOSGlobal?.requestBodyValues?.Warranty == true;
    let isLeadOnly = window?.objOSGlobal?.requestBodyValues?.IsLeadOnly;

    let startStepPercent: Number = window.innerWidth < 767 ? 6.3 : step == "contact-information-screen" ? 3.7 : 3.3;
    let modifier = sessionStorage.getItem('ServiceModifierValue');
    switch (step) {
        case "calendar-screen":
            percent = startStepPercent; //3.3;
            $('.progress-bar').css({ width: percent + '%' });
            break;
        case "about-home-screen":
            if(modifier =='Commercial'){
                percent = startStepPercent;
            }else{
                if(isLeadOnly){
                    percent = startStepPercent; //3.7;
                }else{
                    percent = (get_data('selectedAboutHome') == 'onetime' || 'recurring') ? 20 : 26;                    
                }
            } 
            $('.progress-bar').css({ width: percent + '%' });
            break;
        case "estimate-screen":
            if(isLeadOnly){
                percent = 26;
            }else{
                percent = 41;
            }
            $('.progress-bar').css({ width: percent + '%' });
            break;
        case "contact-information-screen":
            // if(get_data('conceptID') == 1){
            //     if(modifier =='Commercial'){
            //         percent = 36;
            //     }else{
            //         percent = isLeadOnly ? (get_data('selectedAboutHome') == 'onetime' || 'recurring') ? 52 : 36 : (get_data('selectedAboutHome') == 'onetime' || 'recurring') ? 62.1 : 52;
            //     }
            // }else if(get_data('conceptID') == 8){
            //     percent = isLeadOnly && !isMRAWarranty ? startStepPercent : isMRAWarranty ?  startStepPercent : 26;
            // }else if(get_data('conceptID') == 14){
            //     percent = isLeadOnly ?  startStepPercent : 20;
            // }else{
                percent = isLeadOnly ?  startStepPercent : 26;
            // }
            $('.progress-bar').css({ width: percent + '%' });
            break;
        case "service-address-screen":
            // if(get_data('conceptID') == 1){
            //     if(modifier =='Commercial'){
            //         percent = 68;
            //     }else{
            //         percent = isLeadOnly ? (get_data('selectedAboutHome') == 'onetime' || 'recurring') ? 77 : 68 : (get_data('selectedAboutHome') == 'onetime' || 'recurring') ? 84 : 77;
            //     }
                
            // }
            // else if(get_data('conceptID') == 14) {
            //     percent = isLeadOnly ? 26 : 41; //get_data('selectedPLGFilter') == 'Auto' ? isLeadOnly ? 26 : 41 :
            // }
            // else{
                percent = isLeadOnly || isMRAWarranty ?  36 : 52;
            // }
            $('.progress-bar').css({ width: percent + '%' });
            if($('#service-address-screen select[name="state"]').children("option:selected").val() !== '') {
              $("#service-address-screen .next").removeClass("disble-btn");
              $("#service-address-screen .next").prop("disabled", false);
            }else {
              $("#service-address-screen .next").addClass("disble-btn");
              $("#service-address-screen .next").prop("disabled", true);
            }
            break;
       case "about-service-needs-screen":
            percent = isLeadOnly ? 52 : 62.1; //get_data('selectedPLGFilter') == 'Auto' ? isLeadOnly ? 52 : 62.1 :
            $('.progress-bar').css({ width: percent + '%' });
            break;
        case "vehicle-information-screen":
            percent = isLeadOnly ? 77 : 84; //get_data('selectedPLGFilter') == 'Auto' ? isLeadOnly ? 77 : 84 :
            $('.progress-bar').css({ width: percent + '%' });
            break;
        case "service-details-screen":
            // if (get_data('conceptID') == '14') {
            //     percent = isLeadOnly ? 77 : 84;
            // }
            // else {
                percent = isLeadOnly || isMRAWarranty ?  68 : 77;
            // }            
            $('.progress-bar').css({ width: percent + '%' });
            break;
        case "8":
            percent = '100';
            $('.progress-bar').css({ width: percent + '%' });
            $(".progress").addClass("d-none");
            $(".progressbar").addClass("d-none");
            $(".modal-header-two").addClass("d-none");
            $(".modal-header-one").addClass("d-none");
            break;
        default:
            percent = startStepPercent;
            $('.progress-bar').css({ width: percent + '%' });
            break;
    }
}